import getCustomization from '../utils/get-customization'

function Home() {
  return getCustomization().home
}

export default Home;
